module.exports = "/fonts/hashed/NotoSansSC-Regular.cafee774.ttf.gz.bin";